import React, { useState } from 'react';
import { SortField, SortDirection } from '../../../../domain/FilterTypes';
import { sortOptions } from '../../../../domain/filterOptions';
import { useClickOutside } from '../../../hooks/useClickOutside';
import { useFilterController } from '../../../../application/useFilterController';
import { ArrowUpDown } from 'lucide-react';

export const SortDropdown = () => {
  const { sortBy, sortDirection, setSort } = useFilterController();

  const [ open, setOpen ] = useState(false);
  const dropdownRef = useClickOutside<HTMLDivElement>(() => setOpen(false));

  // Find the selected option based on both sortBy and sortDirection
  const selectedOption = sortOptions.find((opt) =>
    opt.value === sortBy && opt.direction === sortDirection
  );

  const onChange = (sortBy: SortField, direction: SortDirection) => {
    console.log('onChange', sortBy, direction);
    setSort(sortBy, direction);
    setOpen(false);
  };
  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        onClick={() => setOpen(prev => !prev)}
        className="border rounded px-3 py-2 bg-white text-gray-800 flex items-center justify-between min-w-[100px] max-w-[120px] sm:max-w-[170px]"
      >
        <ArrowUpDown className="w-4 h-4 text-gray-500 flex-shrink-0 mr-2" />

        <span className="truncate text-sm sm:text-base">
          {selectedOption?.label || 'Sort'}
        </span>
      </button>

      {open && (
        <div className="absolute left-0 mt-2 w-56 bg-white border rounded shadow-lg z-10">
          {sortOptions.map((opt, idx) => {
            const isSelected =
              opt.value === sortBy &&
              opt.direction === sortDirection;

            return (
              <button
                key={`${opt.value}-${opt.direction}-${idx}`}
                onClick={() => onChange(opt.value, opt.direction)}
                className={`block w-full text-left px-4 py-2 text-sm hover:bg-blue-400 transition-colors ${
                  isSelected ? 'bg-blue-200 font-medium' : ''
                }`}
              >
                {isSelected && <span className="mr-2">✓</span>}
                {opt.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
